import {globals, globalUser} from "../modules/globals.js";
import {getHomePageData} from "../modules/games.js";
import {
    disabledMenuButtonHandler,
    gameOverMenuButtonHandler,
    resetMenuButtonClickHandlers,
    showChangeCurrentCompanyData
} from "./game-menu.js";
import {
    formatCompanyName,
    getChampionshipPrestigeIconHtml,
    getFansHtml,
    getPointsHtml,
    hideContent,
    makeGameRequest,
    monthNames
} from "./ui-helpers.js";
import {loadDashboard, showDashboardData} from "./dashboard.js";
import {showSuperstarInformation, showTagteamInformation} from "./booking.js";
import {callupAvailableTrainingTalent, getAvailableCallupsData} from "../modules/rosters.js"
import {playSoundEffect} from "./sounds.js";
import {displayYearlyRankingsData, showEventCardData} from "./manage-sub-menu.js";
import {introducePowerupsView} from "../modules/powerups.js";
import {introduceSpecialSegmentsView} from "../modules/segments.js";
import {commaSeparate, getCurrentGame, getMonthsWord, shuffle} from "../modules/helpers.js";
import {showCustomStartingCompanyChampionshipGraphic, showTalentDialogPageGraphic} from "./graphics.js";
import {loadViewRosterMemberPage} from "./roster-sub-menu.js";
import {acceptOrRejectTalentOfferRequest} from "../modules/negotiations.js";
import {
    changeCurrentCompany,
    confirmBuyoutSelections,
    confirmNewCompanyDetails, confirmNewCompanyTalent
} from "../modules/companies.js";
import {acceptTalentRequestView, changeTalentRequestView, declineTalentRequestView} from "../modules/talentRequests.js";
import {showDraftPage} from "./drafts.js";
import {
    dialogPersonChoiceHandler,
    selectDialogPersonHandler,
    showGetPowDialogData,
    showNPCDialog,
    showReactionDialog
} from "./dialog.js";
import {processAwards} from "../modules/awards.js";
import {addRandomEventChoice} from "../modules/randomEvents.js";
import {loadTradeSuperstarInfoPage} from "./trades.js";
import {replyToTradeOfferRequest} from "../modules/trades.js";
import {getPowDialog} from "../modules/passionOfWrestling.js";
import {checkTutorialStepAction, runTutorialState} from "./tutorial.js";

let updateAlertShown = false;
const updateVersion = '4.4';

$(document).ready(function() {
    // ** BUYOUTS **

    // Select buyout superstars
    $(".buyout-competitor-selection-superstars").on('click', '.buyout-competitor-selection-item', function () {
        if ($(this).hasClass('disabled')) {
            return;
        }
        let parent = $(this).parent();
        let signingsAvailable = parseInt($('.buyout-competitor-selection-signings-available').data('value'));
        let signingsSelected = parent.find('.buyout-competitor-selection-item.selected');
        if ($(this).hasClass('selected')) {
            $(this).removeClass('selected')
        }
        else {
            // If at signing limit, don't select
            if (signingsSelected.length >= signingsAvailable) {
                notie.alert({type: 4, text: 'You can\'t select more than {0} Superstars to sign'.format(signingsAvailable), stay: true});
                return;
            }
            $(this).addClass('selected')
        }

        // Update signings available
        signingsSelected = parent.find('.buyout-competitor-selection-item.selected');
        let signingsRemaining = signingsAvailable - signingsSelected.length;
        $('.buyout-competitor-selection-signings-available').text(signingsRemaining + ' Selections Available');

        // Update superstars selected
        let selectedNames = Array.from(signingsSelected, function(el) {
            return $(el).find('.buyout-competitor-selection-item-name').text()
        });
        let superstarsSelected = (selectedNames.length > 0) ? commaSeparate(selectedNames) : 'None';
        $('.buyout-competitor-selection-superstars-selected').text(superstarsSelected);
    });

    // Select buyout championships
    $(".buyout-competitor-selection-championships").on('click', '.buyout-competitor-selection-item', function () {
        if ($(this).hasClass('disabled')) {
            return;
        }
        let parent = $(this).parent();
        let championshipsAvailable = parseInt($('.buyout-competitor-selection-championships-available').data('value'));
        let championshipsSelected = parent.find('.buyout-competitor-selection-item.selected');
        if ($(this).hasClass('selected')) {
            $(this).removeClass('selected')
        }
        else {
            // If at championships limit, don't select
            if (championshipsSelected.length >= championshipsAvailable) {
                notie.alert({type: 4, text: 'You can\'t select more than {0} Championships to acquire'.format(championshipsAvailable),
                    stay: true});
                return;
            }
            $(this).addClass('selected')
        }

        // Update championships available
        championshipsSelected = parent.find('.buyout-competitor-selection-item.selected');
        let championshipsRemaining = championshipsAvailable - championshipsSelected.length;
        $('.buyout-competitor-selection-championships-available').text(championshipsRemaining + ' Selections Available');

        // Update championships selected
        let selectedNames = Array.from(championshipsSelected, function(el) {
            return $(el).find('.buyout-competitor-selection-item-name').text()
        });
        championshipsSelected = (selectedNames.length > 0) ? commaSeparate(selectedNames) : 'None';
        $('.buyout-competitor-selection-championships-selected').text(championshipsSelected);
    });

    // Confirm buyout selections
    $(".buyout-competitor-selection-box").on('click', '#confirm-buyout-selections', async function () {
        let parent = $('.buyout-competitor-selection-box');

        // Get superstars
        let superstarsParent = $(".buyout-competitor-selection-superstars");
        let superstarUids = Array.from(superstarsParent.find('.buyout-competitor-selection-item.selected'), function(el) {
            return $(el).data('uid')
        });
        let sendAllToMainRoster = parent.find('input[value="send_all_to_main_roster"]').prop('checked');
        let signingsAvailable = parseInt($('.buyout-competitor-selection-signings-available').data('value'));

        // Get championships
        let championshipsParent = $(".buyout-competitor-selection-championships");
        let championshipUids = Array.from(championshipsParent.find('.buyout-competitor-selection-item.selected'), function(el) {
            return $(el).data('uid')
        });
        let championshipsAvailable = parseInt($('.buyout-competitor-selection-championships-available').data('value'));

        // Get company uid
        let companyUid = parent.data('uid');

        // Validate superstars and championships, ask for confirmation is not all selected
        let confirmText = '';
        if (superstarUids.length === 0) {
            confirmText = 'If you don\'t select any Superstars, the Owner will select them for you. Are you sure you want to confirm?';
        }
        else if (superstarUids.length < signingsAvailable) {
            confirmText = 'You haven\'t selected all Superstars available to you. Are you sure you want to confirm?'
        }
        else if (championshipUids.length === 0) {
            confirmText = 'If you don\'t select any Championships, the Owner will select them for you. Are you sure you want to confirm?';
        }
        else if (championshipUids.length < championshipsAvailable) {
            confirmText = 'You haven\'t selected all Championships available to you. Are you sure you want to confirm?'
        }
        if (confirmText) {
            notie.confirm({
                text: confirmText,
                submitCallback: async function () {
                    await makeGameRequest(confirmBuyoutSelections, {superstarUids, championshipUids, companyUid,
                        sendAllToMainRoster}, showConfirmBuyoutSelectionsData, {}, false);
                }
            })
        }
        else {
            await makeGameRequest(confirmBuyoutSelections, {superstarUids, championshipUids, companyUid,
                sendAllToMainRoster}, showConfirmBuyoutSelectionsData, {}, false);
        }
    });

    // ** TALENT OFFERS **
    const $talentOfferBox = $('.talent-offer-box');

    // Show talent details for incoming offer
    $talentOfferBox.on('click', '#view-talent-details', async function () {
        let dataType = $('.talent-offer-box').data('type');
        let uid = $('.talent-offer-box').data('uid');
        await loadViewRosterMemberPage(uid, dataType, null, '.talent-offer-box');
    });

    // Accept talent offer
    $talentOfferBox.on('click', '#accept-talent-offer', async function () {
        notie.confirm({
            text: 'Are you sure?',
            submitCallback: async function () {
                let uid = parseInt($('.talent-offer-box .talent-offer-box-offer-item.selected').attr('data-uid'));
                await makeGameRequest(acceptOrRejectTalentOfferRequest, {uid, selectedChoice: 'accept'},
                    showAcceptOrRejectTalentOfferRequestData, {}, false);
            }
        });
    });

    // Reject talent offer
    $talentOfferBox.on('click', '#reject-talent-offer', async function () {
        let uid = parseInt($('.talent-offer-box .talent-offer-box-offer-item.selected').attr('data-uid'));
        await makeGameRequest(acceptOrRejectTalentOfferRequest, {uid, selectedChoice: 'reject'},
            showAcceptOrRejectTalentOfferRequestData, {}, false);
    });

    // Select talent offer
    $talentOfferBox.on('click', '.talent-offer-box-offer-item', function () {
        $('.talent-offer-box-offer-item').find('.fa-check').removeClass('opaque').hide();
        $('.talent-offer-box-offer-item').removeClass('selected');
        $(this).addClass('selected');
        $(this).find('.fa-check').show();
    });

    // Hover over talent offer
    $talentOfferBox.on('mouseover', '.talent-offer-box-offer-item', function () {
        $('.talent-offer-box-offer-item:not(.selected)').find('.fa-check').removeClass('opaque').hide();
        if (!$(this).hasClass('selected')) {
            $(this).find('.fa-check').addClass('opaque').show();
        }
    });
    $talentOfferBox.on('mouseleave', '.talent-offer-box-offer-item', function () {
        $('.talent-offer-box-offer-item:not(.selected)').find('.fa-check').removeClass('opaque').hide();
    });

    // ** TRADE OFFERS **

    // Accept trade offer
    $(".incoming-trade-offer-container").on('click', '.accept-trade-offer-button', async function () {
        notie.confirm({
            text: 'Are you sure?',
            submitCallback: async function () {
                const tradeOfferUid = $('.incoming-trade-offer-container').data('uid');
                const selectedChoice = 'accept';
                await makeGameRequest(replyToTradeOfferRequest, {tradeOfferUid, selectedChoice},
                    showReplyToTradeOfferRequestData, {selectedChoice}, false);
            }
        });
    });

    // Decline trade offer
    $(".incoming-trade-offer-container").on('click', '.decline-trade-offer-button', async function () {
        const tradeOfferUid = $('.incoming-trade-offer-container').data('uid');
        const selectedChoice = 'decline';
        await makeGameRequest(replyToTradeOfferRequest, {tradeOfferUid, selectedChoice},
            showReplyToTradeOfferRequestData, {selectedChoice}, false);
    });

    // Show superstar info when clicking on trade superstar
    $(".incoming-trade-offer-container").on('click', '.trade-offer-superstar-item', async function() {
        let uid = parseInt($(this).attr('data-uid'));
        await loadTradeSuperstarInfoPage(uid);
    });


    // ** POW **

    // 'Talk' button
    $('#container').on('click', '#pow-talk-button', async function () {

        // Don't allow if PoW dialog showing
        if ($('#pow-dialog').is(':visible')) {
            notie.alert({type: 4, text: "Please finish the current action before proceeding"});
            return false;
        }

        // Don't show if failure ending
        if (globals.game.powStoryFailureEnding) {
            notie.alert({type: 4, text: "There is no one available to talk to."});
            return false;
        }

        await makeGameRequest(getPowDialog, {}, showGetPowDialogData, {});
    });

    // Show person choices
    $('#container').on('click', '#select-dialog-person', function () {
        selectDialogPersonHandler();
    });

    // Show dialog for selected person
    $('#container').on('click', '.dialog-person-choice', function () {
        let name = $(this).text().trim();
        dialogPersonChoiceHandler(name);
    });

    // Go back to dashboard
    $('#game').on('click', '.back-to-dashboard-button', function () {
        playSoundEffect('success');
        hideContent($());
        $("#dashboard-container").fadeIn('slow');
    });

    // ** FORM NEW COMPANY **

    // Add championship input
    const $formNewCompanyDetailsBox = $('.form-new-company-details-box');
    $formNewCompanyDetailsBox.on('click', '.add-form-new-company-championship-input-button', function () {

        // Get existing championships selects
        let parentBox = $(this).closest('.box');
        let championshipInputs = parentBox.find('.form-new-company-championship-name-input');

        // Check for maximum championships selects
        if (championshipInputs.length >= 5) {
            notie.alert({type: 3, text: 'You cannot add more than 5 championships'});
            return false;
        }

        // Clone championship input, add remove button
        let championshipInput = '<div class="margin-bottom-8">' + championshipInputs.eq(0).parent().clone().prop('innerHTML') +
            '<button type="button" class="remove-form-new-company-championship-input-button button retro-button styled-select-button ' +
            'font-bold top-1px margin-left-3"><i class="fa fa-minus"></i></button></div>';

        // Add championship input after last one
        championshipInputs.last().parent().after(championshipInput);

        // Reset graphic
        let addedInputParent = parentBox.find('.form-new-company-championship-name-input').last().parent();
        addedInputParent.find('.form-new-company-championship-remove-graphic-button').hide();
        addedInputParent.find('.form-new-company-championship-add-graphic-button').text('Add Graphic')
            .addClass('dark-grey-button-background').removeClass('blue-button-background');
        addedInputParent.data('key', null);
    });

    // Remove championship input
    $formNewCompanyDetailsBox.on('click', '.remove-form-new-company-championship-input-button', function () {
        $(this).parent().remove();
        processFormNewCompanyOpenGraphicCreator();
    });

    // Add/edit championship graphic
    $formNewCompanyDetailsBox.on('click', '.form-new-company-championship-add-graphic-button', function () {
        let parent = $(this).parent();

        processFormNewCompanyOpenGraphicCreator();

        // Select this button
        $(this).text('Edit Graphic').removeClass('dark-grey-button-background').addClass('blue-button-background');

        // Show remove graphic button
        $(this).siblings('.form-new-company-championship-remove-graphic-button').show();

        // Set graphic data
        let jsonData;
        let graphicData;
        if (parent.data('key')) {
            jsonData = JSON.parse(parent.data('key'))
        }
        if (jsonData) {
            graphicData = [jsonData]
        }

        // Show graphic
        let graphicContainer = $(this).parent().siblings('.character-creator');
        let el = graphicContainer.find('.superstar-graphic');
        graphicContainer.show();
        showCustomStartingCompanyChampionshipGraphic(el, graphicData);
    });

    // Remove championship graphic
    $formNewCompanyDetailsBox.on('click', '.form-new-company-championship-remove-graphic-button', function () {
        let parent = $(this).parent();
        $(this).hide();

        processFormNewCompanyOpenGraphicCreator();

        // Remove graphic data
        parent.data('key', null);
        parent.find('.form-new-company-championship-add-graphic-button').text('Add Graphic')
            .addClass('dark-grey-button-background').removeClass('blue-button-background');
    });

    // Confirm new company details
    $formNewCompanyDetailsBox.on('click', '#form-new-company-confirm-details-button', function () {

        // Get input values
        let parent = $('.form-new-company-details-box');
        let companyName = parent.find('.form-new-company-name-input').val();
        let trainingRosterOption = parent.find('.form-new-company-training-roster-select').val();
        let weeklyShowName = parent.find('.form-new-company-weekly-show-name-input').val();
        let companyStyle = parent.find('.form-new-company-style-select').val();

        // Get event and championship names and prestiges
        let companyMonthlyEventsData = [];
        parent.find('.form-new-company-event-name-input').each(function (i, e) {
            let eventName = $(e).val();
            let eventPrestige = $(e).next('.form-new-company-event-prestige-select').val();
            let companyMonthlyEventData = {
                'name': eventName,
                'prestige': eventPrestige
            }
            companyMonthlyEventsData.push(companyMonthlyEventData);
        });

        processFormNewCompanyOpenGraphicCreator(false);
        let companyChampionshipsData = [];
        parent.find('.form-new-company-championship-name-input').each(function (i, e) {
            let championshipName = $(e).val();
            if (championshipName) {
                let championshipDivision = $(e).siblings('.form-new-company-championship-division-select').val();
                let championshipPrestige = $(e).siblings('.form-new-company-championship-prestige-select').val();
                let championshipGraphicData = $(e).parent().data('key');
                let companyChampionshipData = {
                    'name': championshipName,
                    'division': championshipDivision,
                    'prestige': championshipPrestige,
                    'graphic': championshipGraphicData
                }
                companyChampionshipsData.push(companyChampionshipData);
            }
        });

        // Validate inputs
        if (companyName.length <= 0) {
            notie.alert({type: 3, text: "Please enter the Company's name"});
            return false;
        }
        let emptyMonthlyEventName = false;
        let duplicateMonthlyEventName = false;
        let monthlyEventNames = [];
        companyMonthlyEventsData.forEach(function (monthlyEventData) {
            if (!monthlyEventData['name']) {
                emptyMonthlyEventName = true;
                return false;
            }
            if (monthlyEventNames.includes(monthlyEventData['name'])) {
                duplicateMonthlyEventName = true;
                return false;
            }
            monthlyEventNames.push(monthlyEventData['name']);
        });
        if (emptyMonthlyEventName) {
            notie.alert({type: 3, text: "Please enter all Monthly Event names"});
            return false;
        }
        if (duplicateMonthlyEventName) {
            notie.alert({type: 3, text: "Please enter unique names for all Monthly Events"});
            return false;
        }

        // Get details data
        let companyDetails = {
            'companyName': companyName,
            'trainingRosterOption': trainingRosterOption,
            'weeklyShowName': weeklyShowName,
            'companyMonthlyEventsData': companyMonthlyEventsData,
            'companyChampionshipsData': companyChampionshipsData,
            'companyStyle': companyStyle,
        };

        notie.confirm({
            text: 'Are you sure?',
            submitCallback: async function () {
                await makeGameRequest(confirmNewCompanyDetails, {companyDetails}, showConfirmNewCompanyDetailsData,
                    {}, false);
            }
        });
    });

    // Select new company superstars
    $(".form-new-company-talent-box").on('click', '.form-new-company-selection-item', function () {
        let parent = $(this).parent();
        let selectionsAvailable = parseInt($('.form-new-company-selections-available').data('value'));
        let superstarsSelected = parent.find('.form-new-company-selection-item.selected');
        if ($(this).hasClass('selected')) {
            $(this).removeClass('selected')
        }
        else {
            // If at signing limit, don't select
            if (superstarsSelected.length >= selectionsAvailable) {
                notie.alert({type: 4, text: 'You can\'t select more than {0} Superstars.'.format(selectionsAvailable), stay: true});
                return;
            }
            $(this).addClass('selected')
        }

        // Update selections available
        superstarsSelected = parent.find('.form-new-company-selection-item.selected');
        let selectionsRemaining = selectionsAvailable - superstarsSelected.length;
        $('.form-new-company-selections-available').text(selectionsRemaining + ' Selections Available');

        // Update superstars selected
        let selectedNames = Array.from(superstarsSelected, function(el) {
            return $(el).find('.form-new-company-selection-item-name').text()
        });
        $('.form-new-company-superstars-selected').text(selectedNames.length > 0 ? commaSeparate(selectedNames) : 'None');
    });

    // Confirm new company talent
    $(".form-new-company-talent-box").on('click', '#form-new-company-confirm-talent-button', async function () {
        // Get superstars
        let superstarsParent = $(".form-new-company-superstars");
        let superstarUids = Array.from(superstarsParent.find('.form-new-company-selection-item.selected'), function(el) {
            return $(el).data('uid')
        });
        let selectionsAvailable = parseInt($('.form-new-company-selections-available').data('value'));

        // Validate superstars, ask for confirmation is not all selected
        let confirmText = '';
        if (superstarUids.length < selectionsAvailable) {
            confirmText = 'You haven\'t selected all Superstars available to you. Are you sure you want to confirm?'
        }
        if (confirmText) {
            notie.confirm({
                text: confirmText,
                submitCallback: async function () {
                    await makeGameRequest(confirmNewCompanyTalent, {superstarUids}, showConfirmNewCompanyDetailsData, {}, false);
                }
            })
        }
        else {
            await makeGameRequest(confirmNewCompanyTalent, {superstarUids}, showConfirmNewCompanyDetailsData, {}, false);
        }
    });

    // ** OTHER **

    // Make random event choice
    $(".random-event-choice-box").on('click', '.random-event-choice-button', async function() {
        let uid = $(this).attr('data-uid');
        let choice = $(this).text();
        await makeGameRequest(addRandomEventChoice, {uid, choice}, showAddRandomEventChoiceData, {}, false);
    });

    // Change company
    $("#container").on('click', '.company-selection-item', async function () {
        let uid = parseInt($(this).attr('data-uid'));
        let $el = $(this);
        await makeGameRequest(changeCurrentCompany, {uid}, showChangeCurrentCompanyData, {$el});
    });

    // Press enter to continue tutorial step, prevent scroll
    $(document).keydown(function (event) {
        if ($('.tutorial-info-continue-button').is(":visible") && event.key === "Enter") {
            event.preventDefault();
            $('.tutorial-info-continue-button').trigger('click')
        }
    });
});

async function loadHomePage(game, hide = true) {

    // Reset ui
    resetMenuButtonClickHandlers('default');
    $('.main-menu-container').find('li').removeClass('selected');
    $('.event-prestige-effects-container').hide();
    $('.event-prestige-effects-more i').addClass('fa-angle-down').removeClass('fa-angle-up');
    globals.currentTutorialStep = null;

    // Get home page data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let homePageData = await getHomePageData(game);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show home page data
    $('.notie-textbox-inner').text('');
    $("#game").fadeIn('slow');
    if (hide) {
        hideContent($());
    }
    await showHomePageData(homePageData, hide);
}

async function showHomePageData(data, hide) {  // Previously game_loop

    // Define jquery selectors
    const $eventCard = $('#event-card');
    const $eventHype = $('.event-hype');
    const $talentRequestBox = $('.talent-request-box');
    const $messagesNumber = $('.messages-number');
    const $bookingContainer = $('#booking-container');
    const $incomingTradeOfferContainer = $('.incoming-trade-offer-container');
    const $talentOfferBox = $('.talent-offer-box');

    if (data['error']) {
        let errorText = 'There was an error loading the game.'
        errorText += ' Please <a href="https://discord.gg/tjwJb99" target="_blank"> contact on Discord</a> for support.';
        notie.alert({type: 3, text: errorText});
        return false;
    }

    // Show dashboard if no other important section displayed
    let showDashboard = true;

    // Set global game attributes
    globals.game.style = data['style'];
    globals.game.month = monthNames[data['currentMonth']];
    globals.game.monthCount = data['monthCount'];
    globals.game.companyMonth = data['companyMonth'];
    globals.game.year = data['realYear'];
    globals.game.competitorsPresent = data['competitorsPresent'];
    globals.game.reputation = data['reputation'];
    globals.game.story = data['story'];
    globals.game.earth = data['earth'];
    globals.game.trainingCallupRun = data['trainingCallupRun'];
    globals.game.marketSize = data['marketSize'];
    globals.game.tutorialState = data['tutorialState'];
    globals.game.annualTournamentRunning = (data['annualTournamentData']) ? data['annualTournamentData']['status'] === 'running' : false;
    globals.game.settings = data['gameSettings'];
    globalUser.settings = data['userSettings'];
    globals.game.weeklyShow = data['eventData']['weeklyShow'];
    globals.game.sandboxModeEnabled = data['gameSettings']['sandbox_mode_enabled'];
    globals.game.unlimitedCreativePoints = data['gameSettings']['unlimited_creative_points'];
    globals.game.maximumRosterCapacity = data['gameSettings']['maximum_roster_capacity'];
    globals.game.controlMultipleCompanies = data['gameSettings']['control_multiple_companies'];
    globals.game.numberOfUserCompanies = data['gameSettings']['number_of_user_companies'];

    // Don't play story, sandbox or local multiplayer not paid
    if (!globalUser.paid && ((data['story'] && data['story'] !== 'tutorial') || data['gameSettings']['sandbox_mode_enabled'] ||
        data['gameSettings']['control_multiple_companies'])) {
        let errorText;
        if (data['story']) {
            errorText = 'Stories are only available in JoW Paid. ';
        }
        else if (data['gameSettings']['sandbox_mode_enabled']) {
            errorText = 'Sandbox Mode is only available in JoW Paid. ';
        }
        else if (data['gameSettings']['control_multiple_companies']) {
            errorText = 'Local Multiplayer is only available in JoW Paid. ';
        }
        notie.alert({
            type: 4, text: errorText, stay: true
        });
        $eventCard.hide();
        resetMenuButtonClickHandlers();

        return false;
    }

    // Set global game owner name
    globals.game.owner = data['owner'] ? data['owner'] + ' (Owner)' : 'Owner';

    // Set powerup icons
    if (globals.game.story === 'mars') {
        globals.game.powerupLevel1 = 'experiment_1_icon';
        globals.game.powerupLevel2 = 'experiment_2_icon';
        globals.game.powerupLevel3 = 'experiment_3_icon';
        globals.game.powerupWord = 'Experiment';
    }
    else {
        globals.game.powerupLevel1 = 'powerup_1_icon';
        globals.game.powerupLevel2 = 'powerup_2_icon';
        globals.game.powerupLevel3 = 'powerup_3_icon';
        globals.game.powerupWord = 'Artifact';
    }

    // Show month and year
    let monthName = globals.game.month.slice(0, 3);
    let year = data['realYear'];

    // Show earth year for mars story
    if (data['earthYear']) {
        year = 'Year {0} (Earth {1})'.format(year, data['earthYear']);
        $(".event-card-month-and-year").text(monthName + ', ' + year);
    }
    else {
        $(".event-card-month-and-year").text(monthName + ' ' + year);
    }

    // Show event card's data
    showEventCardData(data);

    $("#main-menu-right").html('');

    // Show company name
    $("#company-name").html(getCompanyHeaderHtml(data['companyName'], data['playerName']));

    // Show points
    let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
    $(".points-number").html(pointsHtml);
    $('#points').show();

    // Show fans
    let fans = getFansHtml(data['fans']);
    $(".fans-number").html(fans);
    $('#fans').show();

    // Get dialogs and append to array
    let dialogs = [];
    if (data['storyEvents']) {
        data['storyEvents'].forEach(function (event) {
            // Get dialogs for each story choice or event
            if (storyData[event['name']]) {
                let storyDialogs = storyData[event['name']];

                // Add information to dialogs
                storyDialogs.forEach(function (dialog, j) {
                    dialog.texts.forEach(function (text, i) {
                        dialog.texts[i] = text.format(event['information'])
                    })
                });

                dialogs.push.apply(dialogs, storyDialogs);
            }
        });

        // Get dialogs for each year and month
        if (storyData[data['year']]) {
            if (storyData[data['year']][data['monthCount']]) {
                dialogs.push.apply(dialogs, storyData[data['year']][data['monthCount']])
            }
        }
    }

    // Show training callups if relevant
    if ((data['companyMonth'] === 0 || data['companyMonth'] === 6) && !data['draftData'] &&
        !data['trainingCallupRun'] && !data['buyoutData'] && !data['randomEvents'].length > 0 &&
        !dialogs.length > 0 && !data['talentOffers'].length > 0 && !data['tradeOffers'].length > 0 &&
        !data['showPowIntroduction'] && !(data['powReactionDialogs'] && data['powReactionDialogs'].length > 0) &&
        !(data['tutorialState'] && data['tutorialState'] !== 'end_tutorial') && !data['yearlyRankingData'] &&
        !data['talentRequestsData'].length > 0 && !data['annualTournamentData']) {
        await loadAvailableCallupsPage(hide);
        showDashboard = false;
    }

    // Annual Tournament
    let annualTournamentDialogsShown = false;
    if (data['annualTournamentData']) {
        // Show dialog
        if (data['annualTournamentData']['dialogData']) {
            showNPCDialog(data['annualTournamentData']['dialogData']);
            annualTournamentDialogsShown = true;
            showDashboard = false;
        }

        if (data['annualTournamentData']['status'] === 'selecting' || data['annualTournamentData']['status'] === 'running') {
            $(".event-prestige-effects").hide();
            $('#match-limits').html('');
            $eventHype.html('');
            $('.event-card-header-container').hide();
            $('.event-card-annual-tournament-header').show();
            $('.event-card-annual-tournament-header-text').text(data['annualTournamentData']['name']);
        }
        else {
            $('.event-card-header-container').show();
            $('.event-card-annual-tournament-header').hide();
        }
    }
    else {
        $('.event-card-header-container').show();
        $('.event-card-annual-tournament-header').hide();
    }

    // Process awards if competitors present and not mars story
    let awardsShown = false;
    if (data['monthCount'] === 10 && data['competitorsPresent'] && (!data['awardsRun']) && (data['story'] !== 'mars')) {
        awardsShown = true;
        showDashboard = false;
        await makeGameRequest(processAwards, {}, showProcessAwardsData, {});
    }

    // Introduce powerups / special segments
    if (!data['eventData']['weeklyShow']) {
        // Show powerups
        if (data['monthCount'] === 1 && data['year'] === 0) {
            await makeGameRequest(introducePowerupsView, {}, showIntroducePowerupsViewData, {}, false, true);
        }

        // Introduce special segments
        if (globalUser.paid && data['monthCount'] === 4 && data['year'] === 0 && data['story'] !== 'mars') {
            await makeGameRequest(introduceSpecialSegmentsView, {}, showIntroduceSpecialSegmentsViewData, {}, false, true);
        }
    }

    // Go through dialogs
    if (dialogs.length > 0) {
        // Disable menu options
        $eventCard.show();
        resetMenuButtonClickHandlers(disabledMenuButtonHandler);
        dialogNameSpace.goThroughDialogs(dialogs);
        showDashboard = false;
    }

    // Get random events to show for choice selection
    let randomEventShown = false;
    if (data['randomEvents'].length > 0 && !awardsShown && !annualTournamentDialogsShown) {
        randomEventShown = true;
        showRandomEventSelection(data['randomEvents']);
        showDashboard = false;
    }

    let notieTexts = '';

    // Anonymous user sign up notification
    if (!globalUser.loggedIn) {
        notieTexts += '<span class="display-block">' +
            'Anonymous users\' saves are not backed up to the cloud and can be lost. Please sign up to enable cloud saves.' +
            '</span>';
    }

    if (!globalUser.freeTrialActivatedDatetime && !globalUser.paid && (data['monthCount'] === 0 || data['monthCount'] === 2)) {
        let jowPaidPromoText;
        if (data['monthCount'] === 0) {
            jowPaidPromoText = '<span class="gold">JoW Paid</span> includes the Ratings War, Staff & Facilities, ' +
            'Company/Title/Talent Stats and much more. <a href="/free-trial" target="_blank">Try it</a> for free!';
        }
        else {
            jowPaidPromoText = '<span class="gold">JoW Paid</span> includes unlimited save slots, unique story modes, ' +
            'Sandbox Mode and much more. <a href="/free-trial" target="_blank">Try it</a> for free!';
        }
        notieTexts += '<span class="display-block">' +
            jowPaidPromoText +
            '</span>';
    }

    if (notieTexts) {
        notie.alert({
            type: 4, text:
            notieTexts, stay: true, prepend: true
        });
    }

    // Show unread messages
    let unreadMessages = data['unreadMessages'].toLocaleString('en');
    $messagesNumber.text(unreadMessages);
    if (data['unreadMessages']) {
        $('.messages-icon').attr('src', 'static/www/static/message_alert_icon.png');
    }
    else {
        $('.messages-icon').attr('src', 'static/www/static/message_icon.png');
    }
    $('#messages').show();

    // Buyout page
    let buyoutShown = false;
    if (data['buyoutData'] && !awardsShown && !annualTournamentDialogsShown) {
        showBuyoutPage(data['buyoutData']);
        buyoutShown = true;
        showDashboard = false;
    }

    // Forming new company page
    let formNewCompanyShown = false;
    if (data['newCompanyData'] && !awardsShown && !annualTournamentDialogsShown && !buyoutShown) {
        // Add company details
        if (data['newCompanyData']['monthsToForm'] === 2 && !data['newCompanyData']['companyDetails']) {
            showFormNewCompanyDetailsPage(data);
            showDashboard = false;
            formNewCompanyShown = true;
        }
        // Select talent
        else if (data['newCompanyData']['monthsToForm'] === 1 && !data['newCompanyData']['talentDetails']) {
            showFormNewCompanyTalentPage(data);
            showDashboard = false;
            formNewCompanyShown = true;
        }
    }

    // Draft page
    let draftShown = false;
    if (data['draftData']) {
        showDraftPage(data['draftData']);
        draftShown = true;
        showDashboard = false;
    }

    // Talent offers
    let talentOfferShown = false;
    if (data['talentOffers'].length > 0 && !(data['powReactionDialogs'] && data['powReactionDialogs'].length > 0) &&
        !(data['tutorialState'] && data['tutorialState'] !== 'end_tutorial') && !awardsShown && !annualTournamentDialogsShown
        && !draftShown && !globalUser.developerMode) {
        talentOfferShown = true;

        // Show talent offer
        let talentOfferIndex = 0;
        let talentOffer = data['talentOffers'][talentOfferIndex];
        displayTalentOffer(talentOffer);

        // Disable menu buttons
        resetMenuButtonClickHandlers(disabledMenuButtonHandler);

        // Continue talent offer
        $talentOfferBox.off('click', '#continue-talent-offer-button');
        $talentOfferBox.on('click', '#continue-talent-offer-button', async function () {

            // Get next talent offer
            talentOfferIndex++;
            talentOffer = data['talentOffers'][talentOfferIndex];
            if (talentOffer) {
                displayTalentOffer(talentOffer);
            }
            else {
                $talentOfferBox.hide();

                // Enable menu buttons
                resetMenuButtonClickHandlers('default');

                // Load home page
                await loadHomePage(await getCurrentGame());
            }
        });

        showDashboard = false;
    }

    // Trade Offers
    let tradeOfferShown = false;
    if (data['tradeOffers'].length > 0 && !(data['powReactionDialogs'] && data['powReactionDialogs'].length > 0) &&
        !(data['tutorialState'] && data['tutorialState'] !== 'end_tutorial') && !awardsShown && !annualTournamentDialogsShown) {
        tradeOfferShown = true;

        // Show trade offer
        let tradeOfferIndex = 0;
        let tradeOffer = data['tradeOffers'][tradeOfferIndex];
        displayIncomingTradeOffer(tradeOffer);

        // Disable menu buttons
        resetMenuButtonClickHandlers(disabledMenuButtonHandler);

        $bookingContainer.find('.participants-box-match-header, .participants-box-segment-header, .participants-box-match-container, ' +
            '.participants-box-callup-header, .participants-box-segment-container, #add-segment, #superstars-menu, #championship_info, ' +
            '.participants-box-draft-header, #booking-talent-container').hide();
        $bookingContainer.find('.participants-box-trade-offer-header').show();

        // Continue trade offer
        $incomingTradeOfferContainer.off('click', '.continue-trade-offer-button');
        $incomingTradeOfferContainer.on('click', '.continue-trade-offer-button', async function () {

            // Get next trade offer
            tradeOfferIndex++;
            tradeOffer = data['tradeOffers'][tradeOfferIndex];
            if (tradeOffer) {
                displayIncomingTradeOffer(tradeOffer);
            }
            else {
                $incomingTradeOfferContainer.hide();

                // Enable menu buttons
                resetMenuButtonClickHandlers('default');

                // Load home page
                await loadHomePage(await getCurrentGame());
            }
        });

        showDashboard = false;
    }

    // New talent requests
    let talentRequestShown = false;
    if (data['talentRequestsData'] && data['talentRequestsData'].length > 0 && !talentOfferShown &&
        !tradeOfferShown && !awardsShown && !buyoutShown && !formNewCompanyShown && !randomEventShown &&
        !annualTournamentDialogsShown && !draftShown && !globalUser.developerMode) {
        talentRequestShown = true;
        let talentRequestChanged = false;

        // Show talent request
        let talentRequestIndex = 0;
        let talentRequest = data['talentRequestsData'][talentRequestIndex];
        displayTalentRequest(talentRequest);

        // Disable menu buttons
        resetMenuButtonClickHandlers(disabledMenuButtonHandler);

        // Continue talent request
        $talentRequestBox.off('click', '.continue-talent-request-button');
        $talentRequestBox.on('click', '.continue-talent-request-button', async function () {

            // Get next talent request unless repeating
            if (!$(this).data('repeat')) {
                talentRequestIndex++;
            }
            talentRequest = data['talentRequestsData'][talentRequestIndex];
            if (talentRequest) {
                displayTalentRequest(talentRequest);
            }
            else {
                // Revert to dashboard
                $talentRequestBox.hide();

                // Enable menu buttons
                resetMenuButtonClickHandlers('default');

                // Show top 50 rankings if present, otherwise run callup if available, otherwise show dashboard
                if (data['yearlyRankingData'] && !(Object.keys(data['yearlyRankingData']).length === 0)) {
                    displayYearlyRankingsData(data['yearlyRankingData'], false);
                }
                else {
                    if ((globals.game.companyMonth === 0 || globals.game.companyMonth === 6) && !globals.game.trainingCallupRun) {
                        await loadAvailableCallupsPage();
                    } else {
                        // Get dashboard data if talent request changed, otherwise show dashboard
                        if (talentRequestChanged) {
                            await loadDashboard()
                        }
                        else {
                            $('#dashboard-container').show();
                        }
                        $('.main-menu-container').find('li').removeClass('selected');
                        $("#main-menu-right").html('');
                        $('#view-dashboard-menu-button').addClass('selected');
                    }
                }
            }
        });

        // Change talent request event handler
        $talentRequestBox.off('click', '.change-talent-request-option');
        $talentRequestBox.on('click', '.change-talent-request-option', async function () {
            // Make change request if allowed
            let talentRequestData = data['talentRequestsData'][talentRequestIndex];
            let talentRequestsData = data['talentRequestsData'];
            if (talentRequestData['changeAllowed']) {
                let uid = talentRequestData['uid'];
                await makeGameRequest(changeTalentRequestView, {uid}, ({data} = {}) => {
                    if (!data['error']) {
                        // Show change dialog
                        showTalentRequestDialogOnly(talentRequestData['changeDialog']);

                        // Insert new request after current request
                        talentRequestsData.splice(talentRequestIndex + 1, 0, data['newTalentRequestData']);

                        talentRequestChanged = true;
                    } else {
                        if (data['error'] === 'talent-request-not-found') {
                            notie.alert({type: 3, text: 'The talent request could not be found. Please try again.'});
                        }
                    }
                }, {}, false);
            } else {
                showTalentRequestDialogOnly(talentRequestData['changeDialog']);
                // Mark continue button to repeat talent request
                $('.continue-talent-request-button').data('repeat', true);
            }
        });

        // Accept talent request event handler
        $talentRequestBox.off('click', '.accept-talent-request-option');
        $talentRequestBox.on('click', '.accept-talent-request-option', async function () {
            let talentRequestData = data['talentRequestsData'][talentRequestIndex];
            let uid = talentRequestData['uid'];
            await makeGameRequest(acceptTalentRequestView, {uid}, ({data} = {}) => {
                if (!data['error']) {
                    // Show dialog
                    showTalentRequestDialogOnly(data['dialog']);
                } else {
                    if (data['error'] === 'talent-request-not-found') {
                        notie.alert({
                            type: 3,
                            text: 'The talent request could not be found. Please try again.'
                        });
                    }
                }
            }, {}, false);
        });

        // Decline talent request handler
        $talentRequestBox.off('click', '.decline-talent-request-option');
        $talentRequestBox.on('click', '.decline-talent-request-option', async function () {
            let talentRequestData = data['talentRequestsData'][talentRequestIndex];
            let uid = talentRequestData['uid'];
            await makeGameRequest(declineTalentRequestView, {uid}, ({data} = {}) => {
                if (!data['error']) {
                    // Show dialog
                    showTalentRequestDialogOnly(data['dialog']);

                    // Update unread messages
                    if (data['unreadMessages'] !== parseInt($messagesNumber.text())) {
                        let unreadMessages = data['unreadMessages'].toLocaleString('en');
                        $('.messages-icon').attr('src', 'static/www/static/message_alert_icon.png');
                        $messagesNumber.text(unreadMessages);
                        $('#messages').hide().fadeIn('fast');
                    }

                    talentRequestChanged = true;
                } else {
                    if (data['error'] === 'talent-request-not-found') {
                        notie.alert({
                            type: 3,
                            text: 'The talent request could not be found. Please try again.'
                        });
                    }
                }
            }, {}, false);
        });

        // Show talent details
        $talentRequestBox.off('click', '.talent-request-view-talent-details-button');
        $talentRequestBox.on('click', '.talent-request-view-talent-details-button', async function() {
            let talentRequestData = data['talentRequestsData'][talentRequestIndex];
            let dataType = talentRequestData['talentType'];
            let talentUid = talentRequestData['talentUid'];
            await loadViewRosterMemberPage(talentUid, dataType, null, '.talent-request-box');
        });

        showDashboard = false;
    }

    // Yearly rankings
    if ((data['yearlyRankingData'] && !(Object.keys(data['yearlyRankingData']).length === 0)) &&
        !talentOfferShown && !tradeOfferShown && !awardsShown && !buyoutShown && !formNewCompanyShown && !randomEventShown &&
        !talentRequestShown && !annualTournamentDialogsShown && !draftShown) {
        displayYearlyRankingsData(data['yearlyRankingData'], false);
        showDashboard = false;
    }

    if (data['powReactionDialogs'] && data['powReactionDialogs'].length > 0) {
        showDashboard = false;
    }

    // Dashboard
    if (data['dashboardData']) {
        showDashboardData(data['dashboardData'])
    }
    if (showDashboard) {
        $('#view-dashboard-menu-button').addClass('selected')
    }
    else {
        $('#dashboard-container').hide();
    }

    // Show hide PoW 'Talk' button
    if (data['story'] === 'passion') {
        $('#pow-talk-button').show()
    }
    else {
        $('#pow-talk-button').hide()
    }

    // PoW dialogs
    if (data['story'] === 'passion' && !awardsShown) {
        // Show producer introduction dialog
        if (data['showPowIntroduction']) {
            $('#pow-talk-button').trigger('click')
        }

        // Show producer reaction dialog
        if (data['powReactionDialogs'] && data['powReactionDialogs'].length > 0) {
            showReactionDialog(data['powReactionDialogs'])
        }

        // If game story ended in failure, disable menu buttons
        globals.game.powStoryFailureEnding = data['powStoryFailureEnding'];
        if (globals.game.powStoryFailureEnding) {
            resetMenuButtonClickHandlers(gameOverMenuButtonHandler);
        }
    }

    // Run tutorial state if not already running
    if (globals.game.tutorialState && !globals.currentTutorialStep) {
        runTutorialState(globals.game.tutorialState)
    }

    // Tutorial action check
    checkTutorialStepAction('go_to_game');

    // Show ads
    if (!globalUser.paid && globals.game.story !== 'tutorial') {
        $('#ads-container').show();
        $('.ad-container').html('<script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js" crossorigin="anonymous"></script>\n' +
                '        <!-- JoW -->\n' +
                '        <ins class="adsbygoogle"\n' +
                '             style="display:block"\n' +
                '             data-ad-client="ca-pub-6641763625967646"\n' +
                '             data-ad-slot="9880553786"\n' +
                '             data-ad-format="auto"\n' +
                '             data-full-width-responsive="true"></ins>\n' +
                '        <script>\n' +
                '            (adsbygoogle = window.adsbygoogle || []).push({});\n' +
                '        </script>');
        // If are are blocked, show ad support message
        if (window.adsJoW === undefined) {
            if (!notieTexts) {
                notie.alert({
                    type: 4,
                    text: "The free version of JoW is supported by ad revenue. Please consider disabling your ad-blocker for this site to help out the game. Thank you!",
                    stay: true
                });
            }
        }
    }
    else {
        $('#ads-container').hide()
    }
}

function showBuyoutPage(buyoutData) {
    const $buyoutCompetitorSelectionSigningsAvailable = $('.buyout-competitor-selection-signings-available');
    const $buyoutCompetitorSelectionSuperstars = $('.buyout-competitor-selection-superstars');
    const $buyoutCompetitorSelectionChampionshipsAvailable = $('.buyout-competitor-selection-championships-available');
    const $buyoutCompetitorSelectionChampionships = $('.buyout-competitor-selection-championships');
    const $buyoutBox = $('.buyout-competitor-selection-box');

    // Show buyout box, details
    $buyoutBox.show();
    $buyoutBox.data('uid', buyoutData['companyUid']);
    $('.buyout-competitor-selection-company-name').text(buyoutData['companyName']);
    $('.buyout-competitor-selection-info').text(
        buyoutData['ownerName'] + ' has allowed you a limited number of Superstars and Championships ' +
        'from ' + buyoutData['companyName'] + '. Select the ones you would like to bring in.'
    );

    // Superstars
    $buyoutCompetitorSelectionSigningsAvailable.text(buyoutData['signingsAvailable'] + ' Selections Available');
    $buyoutCompetitorSelectionSigningsAvailable.data('value', buyoutData['signingsAvailable']);
    let superstarsHtml = '';
    buyoutData['superstars'].forEach(function(superstar) {
        superstarsHtml += getBuyoutSuperstarsSelectionHtml(superstar)
    });
    $buyoutCompetitorSelectionSuperstars.html(superstarsHtml);
    $buyoutBox.find('input[value="send_all_to_main_roster"]').prop('checked', false);

    // Championships
    $buyoutCompetitorSelectionChampionshipsAvailable.text(buyoutData['championshipsAvailable'] + ' Selections Available');
    $buyoutCompetitorSelectionChampionshipsAvailable.data('value', buyoutData['championshipsAvailable']);
    let championshipsHtml = '';
    buyoutData['championships'].forEach(function(championship) {
        championshipsHtml += getBuyoutChampionshipsSelectionHtml(championship)
    });
    $buyoutCompetitorSelectionChampionships.html(championshipsHtml);

    // Reset selections scroll, selected text
    $buyoutCompetitorSelectionSuperstars.scrollTop(0);
    $('.buyout-competitor-selection-superstars-selected').text('None');
    $buyoutCompetitorSelectionChampionships.scrollTop(0);
    $('.buyout-competitor-selection-championships-selected').text('None');

    hideContent($buyoutBox);

    // Disable menu buttons
    resetMenuButtonClickHandlers(disabledMenuButtonHandler);
}

function getBuyoutSuperstarsSelectionHtml(superstar) {
    let availableClass = '';
    if (!superstar['available']) {
        availableClass = ' disabled'
    }
    let popularity = '<span class="margin-left-10">' +
                     '<i class="fa fa-angle-double-up margin-right-5"></i>' + superstar['popularity'] + '</span>';
    let age = '<span class="margin-left-10 light-grey">' + superstar['age'] + ' y/o</span>';
    let appearances = (superstar['appearances'] !== null) ? '<span class="light-grey">' + superstar['appearances'] + ' apps.</span>' : '';

    // Superstar name, color and help text
    let superstarNameClass = '';
    let superstarHelpTexts = []
    if (superstar['appearances'] !== null) {
        superstarNameClass = 'blue';
        superstarHelpTexts.push('Part-timer')
    }
    if (superstar['championships'].length > 0) {
        superstarNameClass = 'gold';
        let championships = Array.from(superstar['championships'], function(championship) {return championship + ' Champion'});
        superstarHelpTexts.push(commaSeparate(championships));
    }
    if (!superstar['available']) {
        superstarHelpTexts.push('Not Available to Sign');
    }
    if (superstar['injured']) {
        superstarNameClass = 'dark-red';
        superstarHelpTexts.push('Injured for {0} months'.format(superstar['injured']));
    }
    if (superstar['retired']) {
        superstarNameClass = 'medium-light-grey';
        superstarHelpTexts.push('Retired');
    }
    if (superstar['fullTimeManager']) {
        superstarNameClass = 'manager-color';
        superstarHelpTexts.push('Full-time Manager');
    }

    let superstarName;
    if (superstarHelpTexts.length > 0) {
        superstarName = '<div class="line-height-1p4 buyout-competitor-selection-item-name ' + superstarNameClass +
            ' help-text display-inline-block" title="' + superstarHelpTexts.join(', ') + '">' + superstar['name']  + '</div>'
    }
    else if (superstarNameClass) {
        superstarName = '<div class="line-height-1p4 buyout-competitor-selection-item-name display-inline-block' +
            superstarNameClass + '">' + superstar['name']  + '</div>'
    }
    else {
        superstarName = '<div class="line-height-1p4 buyout-competitor-selection-item-name display-inline-block">' +
            superstar['name'] + '</div>'
    }

    return '<div class="inner-box-item buyout-competitor-selection-item' + availableClass + '" data-uid="' + superstar['uid'] + '">' +
        '<div class="medium-dark-grey">' +
        '<div class="buyout-competitor-selection-item-column-left">' +
        superstarName +
        '</div>' +
        '<div class="buyout-competitor-selection-item-column-right">' +
        '<span>' +
        appearances + age + popularity +
        '</span>' +
        '</div>' +
        '<div class="clear"></div>' +
        '</div>' +
        '</div>';
}

function getBuyoutChampionshipsSelectionHtml(championship) {
    // Get name and prestige icon
    let championshipPrestigeIcon = '<span class="margin-left-6">' +
        getChampionshipPrestigeIconHtml(championship['prestige']) +
        '</span>';
    let championshipName = '<div class="buyout-competitor-selection-item-name line-height-1p4">' +
        championship['name'] + championshipPrestigeIcon + '</div>';

    // Get rank and division
    let rank = '<span class="margin-left-10 light-grey">' + championship['rank'] + '</span>';
    let division = '';
    if (championship['tag']) {
        division = '<span class="medium-light-grey">Tag</span>'
    }
    if (championship['trio']) {
        division = '<span class="medium-light-grey">Trio</span>'
    }

    return '<div class="inner-box-item buyout-competitor-selection-item" data-uid="' + championship['uid'] + '">' +
        '<div class="medium-dark-grey">' +
        '<div class="buyout-competitor-selection-item-column-left">' +
        championshipName +
        '</div>' +
        '<div class="buyout-competitor-selection-item-column-right">' +
        division + rank +
        '</div>' +
        '<div class="clear"></div>' +
        '</div>' +
        '</div>';
}

function getCompanyHeaderHtml(companyName, playerName) {
    if (companyName.length > 18) {
        companyName = formatCompanyName(companyName)
    }
    let html = companyName;
    if (globals.game.sandboxModeEnabled) {
        html = '<span class="sandbox-mode-color help-text" title="Sandbox Mode">' + html + '</span>';
    }
    if (globals.game.story === 'passion') {
        html = '<span class="pow-color">' + html + '</span>';
    }
    if (globals.game.controlMultipleCompanies) {
        if (playerName) {
            html += '<span class="light-grey margin-left-8">{0}</span>'.format(playerName);
        }
        $('.change-company-button').show();
    }
    else {
        $('.change-company-button').hide();
    }
    return html
}

async function loadAvailableCallupsPage(hide = true) {

    // Get available callups data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    let availableCallupsData = await getAvailableCallupsData();
    notie.hideAlerts();

    // Show available callups data
    if (availableCallupsData) {
        if (hide) {
            hideContent($());
        }
        showAvailableCallupsPage(availableCallupsData);
    }

    // Callup talent handler
    $(document).off('click', '#booking-talent-container .superstar-select');
    $(document).on('click', '#booking-talent-container .superstar-select', callupAvailableTrainingTalentRequest);
}

function showAvailableCallupsPage(data) {
    // Declare jquery selectors
    const $bookingTalentInfo = $('#booking-talent-info');
    const $superstars = $('#booking-talent-container');
    const $bookingContainer = $('#booking-container');
    const $training = $('#training');

    // Show superstar info
    $bookingTalentInfo.html(
        '<div class="superstar-information-container font-bold medium-grey">' +
        'Roster Member Details' +
        '<div class="empty-superstar-info light-grey">' +
        '<div class="vertical-center">Hover over a Roster Member to display their details here</div>' +
        '</div>' +
        '</div>'
    );
    $bookingTalentInfo.removeClass('match').fadeIn();

    // Reset superstars and booking container
    $superstars.find('.superstar-select, .none-team-text, .none-callups-text').remove();
    $superstars.show();
    $superstars.children().hide();
    $('.participants-box-callup-header').show();
    $bookingContainer.show();
    $bookingContainer.find('.participants-box-match-header, .participants-box-segment-header, .participants-box-match-container, ' +
        '.participants-box-segment-container, #add-segment, #booking-talent-menu, #booking-championship-info, .participants-box-draft-header, ' +
        '.participants-box-trade-offer-header').hide();

    // Show available callups
    data.forEach(function (training) {
        $training.append(
            '<button type="button" class="font-bold superstar-select roster-item-member" ' +
            'data-type="' + training['type'] + '" data-uid="' + training['uid'] + '">' +
            training['name'] + '</button>');
    });
    if (data.length <= 0) {
        $training.append(
            '<span class="font-bold light-grey margin-left-2 none-callups-text">No Talent available</span>');
    }
    $training.fadeIn();
    $superstars.scrollTop(0);

    // Show talent info handler
    let mouseEnterTimer;
    $training.off('mouseenter mouseleave', '.roster-item-member');
    $training.on({
        mouseenter: function (event) {
            mouseEnterTimer = setTimeout(function () {
                showTrainingTalentInformation($(event.target), data)
            }, 50);
        },
        mouseleave: function () {
            clearTimeout(mouseEnterTimer);
        }
    }, ".roster-item-member");
}

async function callupAvailableTrainingTalentRequest() {
    const $el = $(this);
    if ($el.parent().closest('div').attr('id') === 'training') {
        if (globals.requestRunning) {
            return;
        }

        // Get talent uid and type
        let talentUid = $el.attr('data-uid');
        let talentType = $el.attr('data-type');

        // Callup talent
        notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
        globals.requestRunning = true;
        let data = await callupAvailableTrainingTalent(talentUid, talentType);
        globals.requestRunning = false;
        notie.hideAlerts();
        $('.notie-textbox-inner').text('');

        // Show callup result
        await showCallupAvailableTrainingTalentRequestResult(data);
    }
}

async function showCallupAvailableTrainingTalentRequestResult(data) {
    if (!data['error']) {
        playSoundEffect('success');
        let overnessIncrease = '<span class="hot-color">' + data['overnessIncrease'] +
            '<span class="margin-left-2">%</span></span>';

        let html = '<span class="display-block">' +
            '<span class="green">Called up </span>' +
            data['name'] + ' to the Main Roster, ' +
            'boosting ' + data['pronoun'] + ' Overness by ' + overnessIncrease + '</span>';

        notie.alert({type: 4, text: html, stay: true, prepend: true});

        // Hide buttons
        $('#booking-talent-container .superstar-select').hide();

        // Go to dashboard
        setTimeout(async function () {
            await loadDashboard();
            $('.main-menu-container').find('li').removeClass('selected');
            $("#main-menu-right").html('');
            $('#view-dashboard-menu-button').addClass('selected');
        }, 1200);
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'talent-not-found') {
            notie.alert({type: 3, text: "The selected talent could not be found. Please try again."});
        }
        if (data['error'] === 'callup-already-run') {
            notie.alert({type: 3, text: "A callup has already been performed."});
        }
    }
}

function showTrainingTalentInformation($el, data) {
    let selectedUid = parseInt($el.attr('data-uid'));
    let member = data.filter(function (obj) {
        return obj.objectName === $el.attr('data-type') && obj.uid === selectedUid;
    })[0];
    if (member) {
        if ($el.attr('data-type') === 'tagTeam') {
            showTagteamInformation(member);
        }
        else {
            showSuperstarInformation(member);
        }
    }
}

function showIntroducePowerupsViewData({data} = {}) {
    if (data['powerupIntroduced']) {
        // Reset notie transition
        notie.setOptions({
            transitionDuration: 0.3
        });

        // Update unread messages
        if (data['unreadMessages']) {
            let unreadMessages = data['unreadMessages'].toLocaleString('en');
            $('.messages-icon').attr('src', 'static/www/static/message_alert_icon.png');
            $('.messages-number').text(unreadMessages);
        }

        // Show notification
        notie.alert({
            type: 4,
            text: '<span class="display-block">New message about an <span class="black">' + globals.game.powerupWord + '</span> available</span>',
            stay: true, prepend: true
        });
    }
}

function showIntroduceSpecialSegmentsViewData({data} = {}) {
    if (data['specialSegmentIntroduced']) {
        // Reset notie transition
        notie.setOptions({
            transitionDuration: 0.3
        });

        // Update unread messages
        if (data['unreadMessages']) {
            let unreadMessages = data['unreadMessages'].toLocaleString('en');
            $('.messages-icon').attr('src', 'static/www/static/message_alert_icon.png');
            $('.messages-number').text(unreadMessages);
        }

        // Show notification
        notie.alert({
            type: 4,
            text: '<span class="display-block">New message about a <span class="special-segment-color">Special</span> Segment available</span>',
            stay: true
        });
    }
}

async function showConfirmBuyoutSelectionsData({data} = {}) {
    if (!data['error']) {
        // Enable menu buttons
        resetMenuButtonClickHandlers('default');

        // Hide button
        $('#confirm-buyout-selections').hide();

        if (data['unreadMessages']) {
            let unreadMessages = data['unreadMessages'].toLocaleString('en');
            $('.messages-icon').attr('src', 'static/www/static/message_alert_icon.png');
            $('.messages-number').text(unreadMessages);
            $('#messages').hide().fadeIn('fast');
        }
        notie.alert({type: 4, text: 'Buyout Confirmed', stay: true});

        // Hide buyout container, load home page
        setTimeout(function () {
            $('.buyout-competitor-selection-box').fadeOut('fast', async function () {
                await loadHomePage(await getCurrentGame());
            });
        }, 1000);
    }
    else {
        if (data['error'] === 'competitor-not-found') {
            notie.alert({type: 3, text: "The Competitor could not be found. Please try again."});
        }
        if (data['error'] === 'no-buyout-running') {
            notie.alert({type: 3, text: "No Buyout is running. Please try again."});
        }
    }
}

function displayTalentOffer(data) {
    let parent = $('.talent-offer-box');
    let el = $('.talent-offer-box-graphic');

    let offerFrom = (data['offers'].length > 1) ? 'Multiple companies' : data['offers'][0]['companyName'];
    let offerWord = (data['offers'].length > 1) ? 'offers' : 'an offer';
    let summaryText = '{0} made {1} for {2}'.format(offerFrom, offerWord, data['name']);
    parent.find('.talent-offer-summary').text(summaryText);
    parent.data('name', data['name']);
    parent.data('uid', data['uid']);
    parent.data('type', data['type']);

    el.data('graphic', data['graphic']);
    showTalentDialogPageGraphic(el, data['graphic']);

    parent.find('.talent-offer-box-dialog-content').text(data['dialog']).hide().fadeIn('fast');

    // Show offers
    let offersHtml = '';
    data['offers'].forEach(function(offer, i) {
        let selected = '';
        let selectedIcon = '<i class="fa fa-check light-green margin-left-8 font-1p25em"></i>';
        if (i === 0) {
            selected = ' selected';
            selectedIcon = '<i class="fa fa-check light-green margin-left-8 font-1p25em"></i>'
        }
        offersHtml +=
            '<div>' +
                '<div class="talent-offer-box-offer-item display-inline-block margin-bottom-2' + selected +
                    '" data-uid="' + offer['uid'] + '">' +
                    '<span class="blue margin-right-3">' +
                    '<img src="static/www/static/cp_icon.png" alt="Points" class="points-image-small margin-right-2"> ' + offer['offeredAmount'] +
                    '</span>' +
                    ' ' + offer['companyName'] +
                    selectedIcon +
                '</div>' +
            '</div>'
    });
    parent.find('.talent-offer-box-amount').html(offersHtml);
    parent.find('.talent-offer-box-offer-container').show();

    parent.find('.talent-offer-box-offer-item:not(".selected") i').hide();

    // Change offer text
    if (data['offers'].length > 1) {
        parent.find('.talent-offer-box-offer-text').text('Offers');
    }
    else {
        parent.find('.talent-offer-box-offer-text').text('Offer');
    }

    parent.find('.talent-offer-box-buttons-container .button').show();
    parent.find('#continue-talent-offer-button').hide();

    parent.fadeIn('fast');
}

function showAcceptOrRejectTalentOfferRequestData({data} = {}) {
    let parent = $('.talent-offer-box');
    parent.find('.talent-offer-box-dialog-content').text(data['dialog']).hide().fadeIn('fast');
    parent.find('.talent-offer-box-buttons-container .button').hide();
    parent.find('#continue-talent-offer-button').show();
    parent.find('.talent-offer-box-offer-container').hide();

    // Update points
    let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
    $(".points-number").html(pointsHtml);

    // Update unread messages
    if (data['unreadMessages'] !== parseInt($('.messages-number').text())) {
        let unreadMessages = data['unreadMessages'].toLocaleString('en');
        $('.messages-icon').attr('src', 'static/www/static/message_alert_icon.png');
        $('.messages-number').text(unreadMessages);
        $('#messages').hide().fadeIn('fast');
    }
}

function displayTalentRequest(data) {
    let parent = $('.talent-request-box');
    let el = $('.talent-request-graphic');

    // Add data attributes
    parent.data('uid', data['talentUid']);
    parent.data('type', data['talentType']);
    parent.data('index', data['talentType']);
    parent.data('changeAllowed', data['changeAllowed']);
    if (data['changeAllowed']) {
        parent.data('changeDialog', data['changeDialog']);
    }

    // Show graphic
    el.data('graphic', data['graphic']);
    showTalentDialogPageGraphic(el, data['graphic'], true);

    // Show dialog
    parent.find('.talent-request-dialog-content').text(data['dialog']).hide().fadeIn('fast');

    // Show status text
    let remainingHtml;
    if (data['status'] === 'created') {
        // Get months remaining
        let monthsRemaining = data['monthsRemaining'];
        if (monthsRemaining === 0) {
            remainingHtml = 'Ends next event';
        } else if (monthsRemaining === 1) {
            remainingHtml = 'Ends next month';
        } else {
            let monthsWord = getMonthsWord(monthsRemaining);
            remainingHtml = 'Ends in {0} {1}'.format(monthsRemaining, monthsWord);
        }
    }
    else {
        // Get completed/failed text
        if (data['status'] === 'completed') {
            remainingHtml = '<span class="green">Request completed</span>'
        }
        else if (data['status'] === 'failed') {
            remainingHtml = '<span class="red">Request failed</span>'
        }
    }
    parent.find('.talent-request-status').html(remainingHtml);

    // Show request and talent name
    parent.find('.talent-request-name').text(data['name']);
    parent.find('.talent-request-talent-name').text(data['talentName']);

    // Show responses
    parent.find('.accept-talent-request-option').text(data['responses']['acceptRequest']);
    parent.find('.decline-talent-request-option').text(data['responses']['declineRequest']);
    parent.find('.change-talent-request-option').text(data['responses']['changeRequest']);

    // Hide responses if finished, show continue button
    if (data['status'] === 'completed' || data['status'] === 'failed') {
        parent.find('.talent-request-response-item').hide();
        parent.find('.continue-talent-request-button').show();
    }
    // Otherwise, show responses, hide continue button
    else {
        parent.find('.talent-request-response-item').show();
        parent.find('.continue-talent-request-button').hide();
    }

    parent.find('.continue-talent-request-button').data('repeat', false);

    parent.fadeIn('fast');
}

function showTalentRequestDialogOnly(dialog) {
    // Show change dialog, hide responses, show continue button
    $('.talent-request-box').find('.talent-request-dialog-content').text(dialog).hide().fadeIn('fast');
    $('.talent-request-box').find('.talent-request-response-item').hide();
    $('.talent-request-box').find('.continue-talent-request-button').show();
}

function getAnnualTournamentSelectionItemHtml(superstar) {
    let popularity = '<span class="margin-left-15">' +
                     superstar['popularity'] + '</span>';
    let appearances = (superstar['appearances'] !== null) ? '<span class="light-grey">' + superstar['appearances'] + ' apps.</span>' : '';

    // Superstar name, color and help text
    let superstarNameClass = '';
    let superstarHelpTexts = [];
    if (superstar['appearances'] !== null) {
        superstarNameClass = 'blue';
        superstarHelpTexts.push('Part-timer')
    }
    if (superstar['championships'].length > 0) {
        superstarNameClass = 'gold';
        let championships = Array.from(superstar['championships'], function(championship) {return championship + ' Champion'});
        superstarHelpTexts.push(commaSeparate(championships));
    }
    if (superstar['injured']) {
        superstarNameClass = 'dark-red';
        let monthsWord = getMonthsWord(superstar['injured']);
        superstarHelpTexts.push('Injured for {0} {1}'.format(superstar['injured'], monthsWord));
    }
    if (superstar['retired']) {
        superstarNameClass = 'medium-light-grey';
        superstarHelpTexts.push('Retired');
    }
    if (superstar['fullTimeManager']) {
        superstarNameClass = 'manager-color';
        superstarHelpTexts.push('Full-time Manager');
    }

    let superstarName;
    if (superstarHelpTexts.length > 0) {
        superstarName = '<div class="line-height-1p4 annual-tournament-selection-item-name ' + superstarNameClass +
            ' help-text display-inline-block margin-right-8" title="' + superstarHelpTexts.join(', ') + '">' + superstar['name']  + '</div>'
    }
    else if (superstarNameClass) {
        superstarName = '<div class="line-height-1p4 annual-tournament-selection-item-name display-inline-block margin-right-8' +
            superstarNameClass + '">' + superstar['name']  + '</div>'
    }
    else {
        superstarName = '<div class="line-height-1p4 annual-tournament-selection-item-name display-inline-block margin-right-8">' +
            superstar['name'] + '</div>'
    }

    let unavailableClass = '';
    if (!superstar['available']) {
        unavailableClass = ' unavailable';
    }

    return '<div class="inner-box-item annual-tournament-selection-item' + unavailableClass + '" data-uid="' + superstar['uid'] + '">' +
        '<div class="medium-dark-grey">' +
        '<div class="annual-tournament-selection-item-column-left">' +
        superstarName +
        '</div>' +
        '<div class="annual-tournament-selection-item-column-right">' +
        '<span>' +
        appearances + popularity +
        '</span>' +
        '</div>' +
        '<div class="clear"></div>' +
        '</div>' +
        '</div>';
}

function showProcessAwardsData({data} = {}) {
    if (!data['error']) {
        if (!(Object.keys(data).length === 0)) {
            // Disable menu buttons
            resetMenuButtonClickHandlers(disabledMenuButtonHandler);

            // Texts
            let introTexts = [
                'Welcome to The Wrestling Spectator Awards {0}! It feels great to say that I\'m your host, {1}. ' +
                'Let\'s get started with my favorite award.',
                'Hello and welcome to The Wrestling Spectator Awards {0}! I, {1}, will be your host for the evening. ' +
                'The first award is, uh, an interesting one.',
                'Good evening! It\'s your host for The Wrestling Spectator Awards {0}, {1}! What an honor it is. ' +
                'Let\'s get to it. The first award is, uh, a weird one.',
                'It\'s time for The Wrestling Spectator Awards {0}! I\'m your host, {1}, and I\'ll try to do a better ' +
                'job than every other incapable host over the years. ' +
                'We\'ll start with the stupidest match award.',
                'It\'s The Wrestling Spectator Awards {0}! What an honor that they chose me, {1}, as the host for this year. ' +
                'We\'ll be starting off with the stupidest match award.'
            ];
            let nomineeTexts = [
                'And the nominees are', 'Here are the nominees',
                'The nominees for this award are', 'Let\'s look at the nominees',
                'Here are the nominees for this award', 'A look at the nominees',
                'Nominees, please', 'Take a look at the nominees', 'The nominees are',
                'The nominees', 'Okay, the nominees are'
            ];
            let winnerTexts = [
                'And the winner is...', 'The winner...',
                'And the winner for this award is...', 'Drumroll please...',
                'The winner, and NEW award holder...', 'The winner is...',
                'The winner, in a landslide vote...', 'The winner, in a close call!',
                'A tough vote, but the winner is clear...', 'A close one! The winner is...',
                'An easy winner this year!', 'Finally, the winner...',
                'And the WINNER...'
            ];
            let nextAwardTexts = [
                'Moving on to the next award!', 'Okay, let\'s go to the next award',
                'The next award is...', 'Bored yet? Okay next award',
                'The next award...', 'Moving on',
                'The next award is', 'Moving on forward',
                'Tu turu tuu', 'The next award is...',
                '*whistles awkwardly*', 'Okay, let\'s keep moving'
            ];
            let endTexts = [
                'Thanks for coming to the awards! Prizes will be distributed now.',
                'Hope you had a nice night everyone! Vote for me as host for the next awards and don\'t forget to collect your prizes!',
                'Thanks for attending the awards. Winners can collect their prizes now. Sorry if I was a bad host.',
                'That\'s it, hope you had a fun evening! We\'ll be giving the winners their prizes now.',
                'That\'s it for this years awards! Make sure to come back next year. Prizes will be given out now.'
            ];
            let awardComments = {
                'Match of the Year': [
                    'What a great match that was!',
                    'I remember I loved that match',
                    'Deserving as well',
                    'An awesome match for sure',
                    'My favorite match too!'
                ],
                'Worst Match of the Year': [
                    'What a terrible match!',
                    'What a bad match that was',
                    'A stinker, indeed',
                    'Ugh, don\'t remind me of it!',
                    'The crowd really booed them that night, as they are now. Okay, that\'s enough.'
                ],
                'Craziest Match of the Year': [
                    'What a crazy match!',
                    'What a spotfest!',
                    'I loved that match!',
                    'Holy shit they did some awesome stuff',
                    'They need to do another one!'
                ],
                'Stupidest Match of the Year': [
                    'That was a really stupid match',
                    'Oh god. What happened there?',
                    'That was indeed a terrible match',
                    'Okay, please stop booing.',
                    'Never again please!'
                ],
                'Wrestler of the Year': [
                    'Hear hear!',
                    'What a great year that wrestler had!',
                    'Deservedly so',
                    'That superstar put on some fantastic matches',
                    'Can\'t wait to see what they do next'
                ],
                'Most Hyped Event of the Year': [
                    'That was a big event!',
                    'What a grand show that was.',
                    'The biggest event of the year!',
                    'An awesome production.',
                    'Man was I excited for that!'
                ],
                'Event of the Year': [
                    'What a great event!',
                    'What a spectacle!',
                    'I loved every minute of it',
                    'An amazing night',
                    'A great performance by everyone there'
                ],
                'Worst Event of the Year': [
                    'A terrible event indeed',
                    'What a bad show they put on',
                    'Okay, you can boo this one',
                    'I agree, didn\'t enjoy it one bit!',
                    'I don\'t know what happened, but it shouldn\'t happen again'
                ],
                'Company of the Year': [
                    'What a great year they had!',
                    'They put on some remarkable shows',
                    'I loved so many things they did',
                    'An amazing run',
                    'Everyone worked really hard there'
                ],
                'Worst Company of the Year': [
                    'They had a terrible year',
                    'What a bad run they went on',
                    'Okay, please stop booing',
                    'Yes, they were pretty bad',
                    'Not a good year for them'
                ],
                'Feud of the Year': [
                    'An awesome feud indeed',
                    'Those two were amazing',
                    'What a great feud!',
                    'Can\'t wait for them to feud again',
                    'One of the highlights of the year'
                ],
                'Worst Feud of the Year': [
                    'That was a waste',
                    'What a bad feud',
                    'Those two can do a lot better than that',
                    'I can\'t believe how bad that was',
                    'What a waste that was'
                ],
                'Segment of the Year': [
                    'A memorable segment indeed',
                    'What a great segment that was!',
                    'We need more segments like that',
                    'Damn that was enjoyable!',
                    'That was really fun to watch'
                ],
                'Worst Segment of the Year': [
                    'A terrible segment',
                    'Bad acting, bad writing',
                    'That really shouldn\'t have happened',
                    'That was just silly',
                    'Why did they do that?'
                ],
                'Championship of the Year': [
                    'A memorable year for the title',
                    'What a great run that title had',
                    'What a great bel— I mean title',
                    'A splendid year for that championship',
                    'We saw some great matches for it'
                ],
                'Faction of the Year': [
                    'A great year for them',
                    'What a run they had this past year',
                    'My favorite faction!',
                    'Can I join you guys?',
                    'They had an incredible run'
                ]
            };

            // Selectors
            let awardNomineeHeader = $('.award-nominee-header');
            let awardName = $('.award-name');
            let awardReward = $('.award-reward');
            let awardNominees = $('.award-nominees');
            awardNomineeHeader.show();

            // Reset
            awardNominees.html('');
            awardNomineeHeader.text('');
            awardName.text('');
            awardReward.text('');
            $('.progress-award-button').remove();
            $('.trophy').html('');
            $('.skip-awards-button').show();

            function displayAward() {

                // Reset
                $('.progress-award-button').remove();

                let award = data['awards'][awardIndex];

                if (awardProgressIndex === 0) {
                    // Show award name and trophy
                    awardNomineeHeader.hide();
                    awardNomineeHeader.text(shuffle(nomineeTexts)[0]);
                    awardNomineeHeader.fadeIn('medium');
                    awardName.hide();
                    awardName.text(award['name']);
                    awardName.fadeIn();

                    // Hide previous nominees and rewards
                    awardReward.hide();
                    awardReward.html('');
                    awardNominees.html('');

                    // Show trophy
                    let trophyHtml = '';
                    switch (award['trophy']) {
                        case 'worst':
                            trophyHtml = 'trophy_icon_trash';
                            break;
                        case 'bronze':
                            trophyHtml = 'trophy_icon_bronze';
                            break;
                        case 'silver':
                            trophyHtml = 'trophy_icon_silver';
                            break;
                        case 'gold':
                            trophyHtml = 'trophy_icon_gold';
                            break;
                    }
                    trophyHtml = '<img alt="' + trophyHtml + '" src="static/www/static/' + trophyHtml + '.png" class="trophy-image large margin-right-8"/>';
                    $('.trophy').html(trophyHtml);
                }
                else if (awardProgressIndex === 1) {
                    awardNominees.html('');
                    award['nominees'].forEach(function (nominee) {
                        let div = $('<div class="award-nominee">' + nominee['name'] + '</div>');
                        awardNominees.append(div);
                        div.hide();
                        div.slideDown('slow');
                    });
                }
                else if (awardProgressIndex === 2) {
                    awardNomineeHeader.hide();
                    awardNomineeHeader.text('');
                    awardNomineeHeader.text(shuffle(winnerTexts)[0]);
                    awardNomineeHeader.fadeIn('medium');
                    awardNominees.html('');
                }
                else if (awardProgressIndex === 3) {
                    let div = $('<div class="award-nominee font-bold">' + award['winner']['name'] + '</div>');
                    awardNominees.html(div).hide().slideDown();
                    if (award['trophy'] === 'worst') {
                        div.addClass('flash-text-green puke-green');
                    }
                    else {
                        div.addClass('flash-text gold-true');
                    }
                }
                else if (awardProgressIndex === 4) {
                    if (award['trophy'] === 'worst') {
                        awardNomineeHeader.text(shuffle(awardComments[award['name']])[0]);
                    }
                    else {
                        awardNomineeHeader.text(shuffle(awardComments[award['name']])[0]);
                    }
                    awardNomineeHeader.hide().fadeIn('medium');

                    // Show reward
                    if (!(Object.keys(award['reward']).length === 0 && award['reward'].constructor === Object)) {
                        let reward;
                        if (award['reward']['points'] > 0) {
                            reward =
                                award['companyName'] + ' gained <span class="white font-bold">' +
                                '<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small margin-left-5 margin-right-5"/>{0}</span>';
                        }
                        else {
                            reward =
                                '<span class="white font-bold">' +
                                '<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small margin-left-5 margin-right-5"/>{0}</span>' +
                                ' were taken away from ' + award['companyName'] + '</span>';
                            award['reward']['points'] *= -1;
                        }
                        awardReward.hide();
                        awardReward.html(reward.format(award['reward']['points']));
                        awardReward.fadeIn('medium');
                    }
                    else {
                        awardReward.hide();
                        awardReward.html('');
                    }
                }
                else if (awardProgressIndex === 5) {
                    // Show next award
                    if (awardIndex < data['awards'].length - 1) {
                        awardNomineeHeader.hide();
                        awardNomineeHeader.text(shuffle(nextAwardTexts)[0]);
                        awardNomineeHeader.fadeIn('medium');
                    }
                    else {
                        endAwards();
                    }
                }

                // Add 'continue' awards button if not end of last award
                if (awardIndex < data['awards'].length - 1 || awardProgressIndex !== 5) {
                    $('.awards-heading').after('<button type="button" class="button retro-button condensed ' +
                        'dark-grey-button-background margin-sides-auto display-block progress-award-button">' +
                        'Continue</button>')
                }
            }

            function endAwards() {
                // End awards
                awardNominees.html('');
                awardNomineeHeader.hide();
                awardNomineeHeader.text(shuffle(endTexts)[0]);
                awardNomineeHeader.fadeIn('medium');
                $('.skip-awards-button').hide();

                // Update points
                let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
                $(".points-number").html(pointsHtml);

                setTimeout(async function () {
                    // Enable menu buttons
                    resetMenuButtonClickHandlers('default');

                    // Load home page
                    await loadHomePage(await getCurrentGame(), false);
                }, 1500);
            }

            // Go through awards
            let awardIndex = 0;
            let awardProgressIndex = 0;

            // Add intro text
            awardNomineeHeader.html('<i class="fa fa-commenting fa-flip-horizontal comment-icon"></i>' +
                shuffle(introTexts)[0].format(globals.game.year, data['host']));

            // Show continue button
            $('.awards-heading').after('<button type="button" class="button retro-button condensed ' +
                'dark-grey-button-background margin-sides-auto display-block progress-award-button">' +
                'Continue</button>');

            // Progress awards button
            $('.awards-box').off('click', '.progress-award-button');
            $('.awards-box').on('click', '.progress-award-button', function () {
                if (awardProgressIndex > 5) {
                    awardIndex += 1;
                    awardProgressIndex = 0;
                }
                displayAward();
                awardProgressIndex += 1;
            });

            // Skip awards button
            $('.awards-box').off('click', '.skip-awards-button');
            $('.awards-box').on('click', '.skip-awards-button', function () {
                notie.confirm({
                    text: 'This will skip ALL awards. Are you sure?',
                    submitCallback: function () {
                        $(this).hide();
                        awardNominees.html('');
                        awardNomineeHeader.text('');
                        awardName.text('');
                        awardReward.text('');
                        $('.progress-award-button').remove();
                        $('.trophy').html('');
                        endAwards();
                    }
                });
            });

        }
        else {
            notie.alert({
                type: 4, text: 'The award shows have already run this year! Come back next year for more ' +
                    'entertaining fun and prizes!',
                stay: true
            });
        }

        $('.awards-box').show();
    }
}

function showRandomEventSelection(randomEvents) {
    resetMenuButtonClickHandlers(disabledMenuButtonHandler);
    hideContent($('.random-event-choice-box'));

    randomEvents.forEach(function (randomEvent) {
        let buttonsHtml = '';
        randomEvent['choices'].forEach(function (choice) {
            let buttonClass = '';
            if (choice === 'Ignore') { buttonClass = ' grey-button-background' }
            if (choice === 'Accept') { buttonClass = ' green-button-background' }
            if (choice === 'Decline' || choice === 'Suspend') { buttonClass = ' red-button-background' }
            let button = '<span class="button retro-button random-event-choice-button margin-right-10' + buttonClass + '" ' +
                'data-uid="' + randomEvent['uid'] + '">' + choice + '</span>';
            buttonsHtml += button;
        });
      $('.random-event-choice-buttons').html(buttonsHtml).show();
      $('.random-event-choice-from').html('- ' + randomEvent['fromName']);
      $('.random-event-choice-content').html(randomEvent['content']);
      $('.random-event-choice-subject').html(randomEvent['subject']);
    })
}

async function showAddRandomEventChoiceData({data} = {}) {
    if (!data['error']) {

        // Hide buttons
        $('.random-event-choice-buttons').hide();

        // Add response text
        if (data['replyContent']) {
            $('.random-event-choice-content').text(data['replyContent']);
        }

        // Update messages
        if (data['unreadMessages'] !== parseInt($('.messages-number').text())) {
            let unreadMessages = data['unreadMessages'].toLocaleString('en');
            $('.messages-icon').attr('src', 'static/message_alert_icon.png');
            $('.messages-number').text(unreadMessages);
            $('#messages').hide().fadeIn('fast');
        }

        setTimeout(function () {
            $('.random-event-choice-box').fadeOut('fast', async function () {
                // Enable menu buttons
                resetMenuButtonClickHandlers('default');

                // Load home page
                await loadHomePage(await getCurrentGame());
            });
        }, 1500);
    }
    else {
        if (data['error'] === 'choice-already-added') {
            notie.alert({type: 3, text: 'You have already responded to this message'});
        }
        else if (data['error'] === 'random-event-not-found') {
            notie.alert({type: 3, text: 'There was a problem finding that message'});
        }
        else if (data['error'] === 'choice-not-found') {
            notie.alert({type: 3, text: 'There was a problem responding to this message'});
        }
    }
}

function displayIncomingTradeOffer(tradeOffer) {
    let parent = $('.incoming-trade-offer-container');
    parent.data('uid', tradeOffer['uid']);

    parent.find('.trade-offer-offered-superstars').html('');
    tradeOffer['offeredSuperstars'].forEach(function(offeredSuperstar) {
        let html = '<div class="trade-offer-superstar-item trade-offer-offered-superstar" ' +
            'data-uid="' + offeredSuperstar['uid'] + '">' + offeredSuperstar['name'] + '<div>';
        parent.find('.trade-offer-offered-superstars').append(html);
    });
    for (let i = 0; i < 5 - tradeOffer['offeredSuperstars'].length; i++) {
        let html = '<div class="trade-offer-superstar-item light-grey disabled">Empty</div>';
        parent.find('.trade-offer-offered-superstars').append(html);
    }

    parent.find('.trade-offer-requested-superstars').html('');
    tradeOffer['requestedSuperstars'].forEach(function(requestedSuperstar) {
        let html = '<div class="trade-offer-superstar-item trade-offer-requested-superstar" ' +
            'data-uid="' + requestedSuperstar['uid'] + '">' + requestedSuperstar['name'] + '<div>';
        parent.find('.trade-offer-requested-superstars').append(html);
    });
    for (let i = 0; i < 5 - tradeOffer['requestedSuperstars'].length; i++) {
        let html = '<div class="trade-offer-superstar-item light-grey disabled">Empty</div>';
        parent.find('.trade-offer-requested-superstars').append(html);
    }

    parent.find('.trade-offer-sender-company-name').text(tradeOffer['senderCompany']);
    parent.find('.trade-offer-receiver-company-name').text(tradeOffer['receiverCompany']);

    let durationText = tradeOffer['duration'];
    if (durationText) {
        durationText = '{0} {1}'.format(durationText, getMonthsWord(durationText))
    }
    else {
        durationText = 'Permanent'
    }
    parent.find('.trade-offer-duration-text').text(durationText);

    parent.find('.continue-trade-offer-button').hide();
    parent.find('.accept-trade-offer-button').show();
    parent.find('.decline-trade-offer-button').show();

    parent.fadeIn('fast');
}

function showReplyToTradeOfferRequestData({data, selectedChoice} = {}) {
    if (!data['error']) {
        let notieText;
        if (selectedChoice === 'accept') {
            notieText = 'Trade offer accepted'
        }
        else {
            notieText = 'Trade offer declined'
        }
        notie.alert({type: 4, text: notieText});

        let parent = $('.incoming-trade-offer-container');
        parent.find('.continue-trade-offer-button').show();
        parent.find('.accept-trade-offer-button').hide();
        parent.find('.decline-trade-offer-button').hide();
        $('#booking-container').hide();

        // Update unread messages
        if (data['unreadMessages']) {
            let unreadMessages = data['unreadMessages'].toLocaleString('en');
            $('.messages-icon').attr('src', 'static/message_alert_icon.png');
            $('.messages-number').text(unreadMessages);
            $('#messages').hide().fadeIn('fast');
        }
    }
    else {
        if (data['error'] === 'trade-offer-not-found') {
            notie.alert({type: 3, text: 'That Trade Offer could not be found. Please try again.'});
        }
    }
}

function processFormNewCompanyOpenGraphicCreator(hide) {
    if (typeof hide === 'undefined') hide = true;
    let openCharacterCreator = $('.form-new-company-championships .character-creator:visible');
    if (openCharacterCreator.length > 0) {
        if (hide) {
            openCharacterCreator.find('.superstar-graphic').html('');
            openCharacterCreator.hide();
        }
        openCharacterCreator.find('.load-character-code-input').val('');
        // Save championship's graphics
        openCharacterCreator.find('.share-character').trigger('click');  // Trigger share and hide it
        openCharacterCreator.find('.share-character-code-container').hide();
        openCharacterCreator.find('.share-character').removeClass('selected');
        let characterData = openCharacterCreator.find('.share-character-code-input').val();
        if (characterData) {
            let selectedChampionship = $('.form-new-company-championship-add-graphic-button.blue-button-background').parent();
            selectedChampionship.data('key', characterData);
            if (hide) {
                selectedChampionship.find('.form-new-company-championship-add-graphic-button')
                    .addClass('dark-grey-button-background').removeClass('blue-button-background');
            }
        }
    }
}

async function showConfirmNewCompanyDetailsData({data} = {}) {
    if (!data['error']) {
        notie.alert({
            type: 4,
            text: 'New message from ' + data['ownerName'] + '.',
            stay: true
        });

        setTimeout(function () {
            // Enable menu buttons
            resetMenuButtonClickHandlers('default');

            $(".form-new-company-details-box").fadeOut('fast', async function () {
                // Load home page
                await loadHomePage(await getCurrentGame());
            });
        }, 1000);
    }
    else {
        if (data['error'] === 'name-exists') {
            notie.alert({type: 3, text: 'A company with that name already exists. Please choose a different name.'});
        }
        else if (data['error'] === 'already-done') {
            notie.alert({type: 3, text: 'This action has already been completed.'});
        }
    }
}

function showFormNewCompanyDetailsPage(data) {
    hideContent($('.form-new-company-details-box'));
    $('.form-new-company-details-info').html(
        `<i class="fa fa-info-circle margin-right-2"></i> Confirm the details of the new company you are forming with ${data['newCompanyData']['ownerName']}.`)
    resetMenuButtonClickHandlers(disabledMenuButtonHandler);
}

function showFormNewCompanyTalentPage(data) {
    hideContent($('.form-new-company-talent-box'));
    $('.form-new-company-talent-info').html(`<i class="fa fa-info-circle margin-right-2"></i> Make offers to talent for your new company. 
Highlighted superstars are sure to join you, while others have a chance to join, based on morale and traits.`)
    resetMenuButtonClickHandlers(disabledMenuButtonHandler);

    // Show superstars
    $('.form-new-company-selections-available').text(data['newCompanyData']['selectionsData']['selectionsAvailable'] + ' Selections Available');
    $('.form-new-company-selections-available').data('value', data['newCompanyData']['selectionsData']['selectionsAvailable']);
    let superstarsHtml = '';
    data['newCompanyData']['selectionsData']['superstars'].forEach(function(superstar) {
        superstarsHtml += getFormNewCompanySelectionHtml(superstar);
    });
    $('.form-new-company-superstars').html(superstarsHtml);

    // Reset selections scroll, selected text
    $('.form-new-company-superstars').scrollTop(0);
    $('.form-new-company-superstars-selected').text('None');
}

function getFormNewCompanySelectionHtml(superstar) {
    let interestedClass = '';
    if (superstar['interested']) {
        interestedClass = ' interested'
    }
    let popularity = '<span class="margin-left-10">' +
                     '<i class="fa fa-angle-double-up margin-right-5"></i>' + superstar['popularity'] + '</span>';
    let age = '<span class="margin-left-10 light-grey">' + superstar['age'] + ' y/o</span>';
    let appearances = superstar['appearances'] !== null ? '<span class="light-grey">' + superstar['appearances'] + ' apps.</span>' : '';

    // Superstar name, color and help text
    let superstarNameClass = '';
    let superstarHelpTexts = []
    if (superstar['appearances'] !== null) {
        superstarNameClass = 'blue';
        superstarHelpTexts.push('Part-timer')
    }
    if (superstar['championships'].length > 0) {
        superstarNameClass = 'gold';
        let championships = Array.from(superstar['championships'], function(championship) {return championship + ' Champion'});
        superstarHelpTexts.push(commaSeparate(championships));
    }
    if (superstar['interested']) {
        superstarHelpTexts.push('Interested In Joining');
    }
    if (superstar['injured']) {
        superstarNameClass = 'dark-red';
        superstarHelpTexts.push('Injured for {0} months'.format(superstar['injured']));
    }
    if (superstar['retired']) {
        superstarNameClass = 'medium-light-grey';
        superstarHelpTexts.push('Retired');
    }
    if (superstar['fullTimeManager']) {
        superstarNameClass = 'manager-color';
        superstarHelpTexts.push('Full-time Manager');
    }

    let superstarName;
    if (superstarHelpTexts.length > 0) {
        superstarName = '<div class="line-height-1p4 form-new-company-selection-item-name ' + superstarNameClass +
            ' help-text display-inline-block" title="' + superstarHelpTexts.join(', ') + '">' + superstar['name']  + '</div>'
    }
    else if (superstarNameClass) {
        superstarName = '<div class="line-height-1p4 form-new-company-selection-item-name display-inline-block' +
            superstarNameClass + '">' + superstar['name']  + '</div>'
    }
    else {
        superstarName = '<div class="line-height-1p4 form-new-company-selection-item-name display-inline-block">' +
            superstar['name'] + '</div>'
    }

    return '<div class="inner-box-item form-new-company-selection-item' + interestedClass + '" data-uid="' + superstar['uid'] + '">' +
        '<div class="medium-dark-grey">' +
        '<div class="form-new-company-selection-item-column-left">' +
        superstarName +
        '</div>' +
        '<div class="form-new-company-selection-item-column-right">' +
        '<span>' +
        appearances + age + popularity +
        '</span>' +
        '</div>' +
        '<div class="clear"></div>' +
        '</div>' +
        '</div>';
}

export {loadHomePage, loadAvailableCallupsPage, getAnnualTournamentSelectionItemHtml}